import type { DemoSourceType } from '../types';
import type { PinterestSourceValue } from './types';

export const previewPinterestSources: DemoSourceType<PinterestSourceValue> = {
  'pinterest-fromupnorth': {
    label: 'Pinterest: @fromupnorth',
    source: {
      platform: 'pinterest',
      connectionType: 'pinterestProfile',
      id: 'kgte962z',
      name: 'Pinterest',
      source: 'https://www.pinterest.com/fromupnorth'
    }
  },
  'pinterest-ohjoy-recipes': {
    label: 'Pinterest: ohjoy/recipes',
    source: {
      platform: 'pinterest',
      connectionType: 'pinterestBoard',
      id: 'kgte765z',
      name: 'Pinterest',
      source: 'https://pinterest.com/ohjoy/recipes/'
    }
  }
};
